import { useCallback, useRef } from "react";
import { useSelector } from "react-redux";
import { toCachedFix } from "@utils/cachedLocation";

/**
 * Cache-only location read — the partner-db delivery boy pattern.
 *
 * NEVER wakes the GPS: no MovexGeo.captureCurrentPosition, no permission
 * prompt, no wait. Reads only `state.location.lastFix` (session-scoped, not
 * persisted), which is fed by the movex.geo tracking stream and by any
 * one-shot capture another screen publishes. Guarded to TODAY so a process
 * left alive overnight can't serve yesterday's fix.
 *
 * Returns a stable synchronous getter; read it at the moment you need the
 * coordinates.
 */
const useCachedLocation = () => {
  const lastFix = useSelector((state) => state.location?.lastFix);
  // Through a ref so the getter stays referentially stable and never goes
  // stale inside long-lived async closures.
  const lastFixRef = useRef(lastFix);
  lastFixRef.current = lastFix;
  return useCallback(() => toCachedFix(lastFixRef.current), []);
};

export default useCachedLocation;
